import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { v4 as uuid } from 'uuid';
import { request } from '../../../../services/request';
import { shouldReportErrorMonitor } from '../../Challenge/helpers/shouldReportErrorMonitor';
import { handleError } from '../../../ErrorHandler/errorHandlerPropsMap';
import { Namespace, Role } from '@wix/ambassador-legends-persona-v1-chat/types';
import { sendChatMessage } from '@wix/ambassador-legends-persona-v1-chat/http';
import { TUTOR_CONFIGURATION_ID } from '../consts';

export default async function (
  flowAPI: ControllerFlowAPI,
  chatId: string,
  message: string,
  store: any,
  programId: string,
  participantId: string,
  attachments?: any,
) {
  const userMessageId = uuid();
  const loadingMessageId = uuid();
  const now = new Date();

  // Add user message and loading assistant message
  const messagesWithLoading = [
    ...(store.messages || []),
    {
      id: userMessageId,
      chatId,
      content: message,
      role: Role.USER,
      createdDate: now,
    },
    {
      id: loadingMessageId,
      chatId,
      content: '',
      role: Role.ASSISTANT,
      createdDate: now,
      status: 'loading',
    },
  ];

  flowAPI.controllerConfig.setProps({
    messages: messagesWithLoading,
  });

  try {
    const sendChatMessageTransaction =
      flowAPI.panoramaClient.transaction('send-chat-message');

    sendChatMessageTransaction.start();

    const baseUrl = flowAPI.controllerConfig.wixCodeApi?.location?.baseUrl as
      | string
      | undefined;
    const additionalMetadata: { key: string; value: string }[] = [
      { key: 'programId', value: programId },
      { key: 'participantId', value: participantId },
    ];
    if (baseUrl) {
      additionalMetadata.push({ key: 'baseUrl', value: baseUrl });
    }

    const assistantResponse = (
      await request({
        flowAPI,
        options: sendChatMessage({
          chatId,
          namespace: Namespace.EDUCATION,
          message,
          chatConfig: {
            configurationId: TUTOR_CONFIGURATION_ID,
          },
          attachments,
          metadata: {
            additionalMetadata,
          },
        }),
        errorOptions: {
          errorCodesMap: { applicationError: {} },
        },
      })
    )?.data?.messages?.[0];

    sendChatMessageTransaction.finish();

    // Update loading message with actual response
    const messages = [
      ...(store.messages || []),
      {
        id: userMessageId,
        chatId,
        content: message,
        role: Role.USER,
        createdDate: now,
      },
      {
        ...assistantResponse,
        id: assistantResponse?.id || loadingMessageId,
        status: 'loaded',
      },
    ];

    store.messages = [...messages];

    flowAPI.controllerConfig.setProps({
      messages,
    });
  } catch (error) {
    const resolvedError = flowAPI.errorHandler.getResolvedError(error);

    handleError({
      error,
      resolvedError,
      context: 'SendChatMessage',
      preventErrorMonitorReport: !shouldReportErrorMonitor(error),
    });

    // Remove loading message on error, keep only previous messages
    flowAPI.controllerConfig.setProps({
      messages: [...store.messages],
    });
  }
}
